export default {
  path: '/wecode/robot-info',
  auth: true,
  preload: false,
  key: 'robot',
  layout: 'outer', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
